import {
  ambientesSchema,
  atelieSchema,
  contatoSchema,
  depoimentoSchema,
  heroSchema,
  processoSchema,
  showroomSchema,
  type Ambientes,
  type Atelie,
  type Contato,
  type Depoimento,
  type Hero,
  type Processo,
  type Showroom,
} from '@plane/shared';
import type { ZodType } from 'zod';

import { apiRequest, ApiRequestError } from '@/services/http-client';

/**
 * Conteúdo de uma seção.
 *
 * Devolve `null` quando a seção ainda não foi salva. A API responde 404 nesse
 * caso, o que é correto para ela; para o painel não é erro, é a primeira vez, e
 * o formulário abre com o conteúdo padrão.
 */
async function buscar<T>(secao: string, schema: ZodType<T>): Promise<T | null> {
  try {
    return await apiRequest(`/api/v1/site-content/${secao}`, schema);
  } catch (erro) {
    if (erro instanceof ApiRequestError && erro.status === 404) return null;

    throw erro;
  }
}

function salvar<T>(secao: string, schema: ZodType<T>, conteudo: T): Promise<T> {
  return apiRequest(`/api/v1/site-content/${secao}`, schema, {
    method: 'PUT',
    body: JSON.stringify(conteudo),
  });
}

export const fetchAmbientes = (): Promise<Ambientes | null> => buscar('ambientes', ambientesSchema);
export const saveAmbientes = (a: Ambientes): Promise<Ambientes> =>
  salvar('ambientes', ambientesSchema, a);

export const fetchAtelie = (): Promise<Atelie | null> => buscar('atelie', atelieSchema);
export const saveAtelie = (a: Atelie): Promise<Atelie> => salvar('atelie', atelieSchema, a);

export const fetchContato = (): Promise<Contato | null> => buscar('contato', contatoSchema);
export const saveContato = (c: Contato): Promise<Contato> => salvar('contato', contatoSchema, c);

export const fetchDepoimento = (): Promise<Depoimento | null> =>
  buscar('depoimento', depoimentoSchema);
export const saveDepoimento = (d: Depoimento): Promise<Depoimento> =>
  salvar('depoimento', depoimentoSchema, d);

export const fetchHero = (): Promise<Hero | null> => buscar('hero', heroSchema);
export const saveHero = (h: Hero): Promise<Hero> => salvar('hero', heroSchema, h);

export const fetchShowroom = (): Promise<Showroom | null> => buscar('showroom', showroomSchema);
export const saveShowroom = (s: Showroom): Promise<Showroom> =>
  salvar('showroom', showroomSchema, s);

export const fetchProcesso = (): Promise<Processo | null> => buscar('processo', processoSchema);
export const saveProcesso = (p: Processo): Promise<Processo> =>
  salvar('processo', processoSchema, p);
